<template>
  <div>
    <b-card class="rounded-0 h-100">
      <b-row>
        <b-col>
          <b-form-group :label="this.$t('message.adminUserDetail.legitimation')">
            <b-form-radio-group
              :disabled="!userIsPolicyHolder"
              buttons
              v-model="legiSelected"
              button-variant="outline-primary"
              :options="legiOptions"/>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="w-75">
        <b-col>
          <b-form-group
            :label="this.$t('message.adminUserDetail.status')"
            :state="$v.newDateOfDeath.$error ? false : null"
            :invalid-feedback="$t('error.personalInformationForm.dateOfBirth')">
            <b-input-group>
              <b-form-radio-group
                buttons
                class="input-group-btn"
                v-model="aliveSelected"
                button-variant="outline-primary"
                :options="doaOptions">
              </b-form-radio-group>

              <b-form-input
                :disabled="aliveSelected2 || !!user.dateOfDeath"
                id="dateOfBirth"
                class="rounded-0 text-right"
                v-model="dateOfDeathField"
                placeholder="TT.MM.JJJJ"
                :state="$v.newDateOfDeath.$error ? false : null"
                @change="$v.newDateOfDeath.$touch()">
              </b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="text-right">
          <b-btn
            variant="primary"
            @click="submitStatus">
            <span class="ti-save mr-2"></span>
            {{ $t('message.adminUserDetail.save') }}
          </b-btn>
        </b-col>
      </b-row>

    </b-card>

  </div>
</template>
<script>
  import utils from '@/utils'
  import {required} from 'vuelidate/lib/validators'

  export default {
    name: 'AdminUserStatus',
    components: {},
    computed: {
      user () {
        return this.$store.getters.userById || {}
      },
      userIsPolicyHolder () {
        const user = this.$store.getters.userById
        if (Object.keys(user).length > 0) {
          const rolesPolicyHolder = user.roles.filter(role => role.roleOfUser === 'POLICY_HOLDER')
          if (rolesPolicyHolder.length > 0) {
            return true
          }
        }
        return false
      },
      dateOfDeathField: {
        get: function () {
          return this.user.dateOfDeath ? this.$moment(this.user.dateOfDeath, 'YYYY-MM-DD').format('DD.MM.YYYY') : null
        },
        set: function (newValue) {
          this.newDateOfDeath = newValue
        }
      },
      aliveSelected: {
        get: function () {
          if (this.user.dateOfDeath) {
            return false
          }
          return this.aliveSelected2
        },
        set: function (newValue) {
          this.aliveSelected2 = newValue
        }
      },
      doaOptions () {
        return [
          {text: this.$t('message.adminUserDetail.alive'), value: true, disabled: !!this.user.dateOfDeath},
          {text: this.$t('message.adminUserDetail.dead'), value: false}
        ]
      },
      legiSelected: {
        get: function () {
          return this.user.isAuthorized
        },
        set: function (newValue) {
          this.user.isAuthorized = newValue
        }
      },
      legiOptions () {
        return [
          {text: this.$t('message.adminUserDetail.yes'), value: true},
          {text: this.$t('message.adminUserDetail.no'), value: false}
        ]
      }
    },
    data () {
      return {
        aliveSelected2: true,
        newDateOfDeath: null
      }
    },
    methods: {
      submitStatus () {
        this.$v.$touch()
        if (!this.$v.$invalid) {
          if (!(this.user.dateOfDeath || this.aliveSelected2)) {
            this.$store.dispatch('markAsDead', {
              id: this.user.id,
              dateOfDeath: this.$moment(this.newDateOfDeath, 'DD.MM.YYYY').format('YYYY-MM-DD')
            }).then(() => {
              this.user.dateOfDeath = (this.user.dateOfDeath || this.aliveSelected2) ? this.user.dateOfDeath : this.newDateOfDeath
              this.showSuccessMsg({
                message: this.$t('message.adminUserStatus.update.death')
              })
            }).catch(() => {
              this.showErrorMsg({
                message: this.$t('error.adminUserStatus.update.death')
              })
            })
          }
          if (this.userIsPolicyHolder) {
            this.$store.dispatch('authorize', {
              id: this.user.id,
              isAuthorized: this.legiSelected
            }).then(() => {
              this.user.isAuthorized = this.legiSelected
              this.showSuccessMsg({
                message: this.$t('message.adminUserStatus.update.legi')
              })
            }).catch(() => {
              this.showErrorMsg({
                message: this.$t('error.adminUserStatus.update.legi')
              })
            })
          } else {
            this.showErrorMsg({
              message: this.$t('error.adminUserStatus.update.legi')
            })
          }
        }
      }
    },
    validations: {
      newDateOfDeath: {
        isValidDate: utils.validators.isValidDate,
        required (value) {
          if (this.aliveSelected2) {
            return true
          } else {
            return required(value)
          }
        }
      }
    },
    notifications: {
      showSuccessMsg: {
        type: 'success'
      },
      showErrorMsg: {
        type: 'error'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/AdminUserStatus.vue